// 2.4.1 Bypass Blocks: the first thing a keyboard user reaches on every page.
// Hidden off-screen until it is focused (see .skip-link in a11y.css).
const skipToMain = (e) => {
  e.preventDefault();
  const target =
    document.querySelector("main, [role='main']") || document.querySelector("h1");
  if (!target) return;
  if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
  target.focus();
  target.scrollIntoView({ block: "start" });
};

const SkipLink = () => (
  <a className="skip-link" href="#main" onClick={skipToMain}>
    Skip to main content
  </a>
);

export default SkipLink;
